(function ($) {
  // 祝日取得
  $.get("https://holidays-jp.github.io/api/v1/date.json", function (holidays) {
    // 日本語ピッカー(日曜はじまり)
    flatpickr.l10ns.ja.firstDayOfWeek = 0;
    // 配送日時
    $("#date").flatpickr({
      locale: "ja",
      disableMobile: true,
      // 出力書式
      dateFormat: "Y/m/d",
      // 日付毎カスタム処理
      onDayCreate: onDayCreate,
      // 3日後から有効
      minDate: new Date().fp_incr(4),
      maxDate: new Date().fp_incr(30),
    });
    // piole受取りサービス
    $("#piole").flatpickr({
      locale: "ja",
      disableMobile: true,
      // 出力書式
      dateFormat: "Y/m/d H:i",
      // 日付毎カスタム処理
      onDayCreate: onDayCreate,
      enableTime: true,
      minTime: "10:00",
      maxTime: "20:00",
      defaultDate: "10:00",
      // 3日後から有効
      minDate: new Date().fp_incr(3),
      maxDate: new Date().fp_incr(30),
    });
    // 日付毎に
    function onDayCreate(dObj, dStr, fp, dayElem) {
      // 土日無効・クラス付与
      var dayOfWeek = dayElem.dateObj.getDay();
      switch (dayOfWeek) {
        case 0:
          $(dayElem).addClass("sunday");
          break;
        case 6:
          $(dayElem).addClass("saturday");
          break;
      }
      // 祝日無効・クラス付与
      var ymd = YMD(dayElem.dateObj);
      if (ymd in holidays) $(dayElem).addClass("jp-holiday");
    }
    // yyyy/mm/dd
        function YMD(d) {
          var Y = d.getFullYear();
          var M = d.getMonth() + 1;
          var D = d.getDate();
          return [Y, ("0" + M).slice(-2), ("0" + D).slice(-2)].join("-");
        }
  });
})(jQuery);


